export const TEACHER = 'professeur';
export const STUDENT = 'élève';